module.exports = __webpack_public_path__ + "media/images/sme-banner-mobile-c0e8f9a2a17b0b8abcc43e45adf9ce97.jpg";